import * as React from "react";
const SvgKeyboardOptionKeyOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z" />
  </svg>
);
export default SvgKeyboardOptionKeyOutlined;
